import Immutable from 'seamless-immutable';

import blockchainapi from '@/api/blockchain';

export default {
  namespace: 'nft',
  state: Immutable({
    sceneInfo: {    // 二维码NFT信息
      holder: {}
    }
  }),
  reducers: {
    update: (state, { data, field }) => {
      return state.merge({ [field]: data });
    }
  },
  actions: {
    /** 查询用户标签 */
    getNftSceneInfo: data => ({
      type: 'nft/update',
      promise: blockchainapi.getNftSceneInfo(data),
      field: 'sceneInfo'
    })
  }
};
